const USE_STAGING = process.env.VUE_APP_ENV === "staging" || process.env.NODE_ENV === "development";

export const MEMCACHIER_BASE_URL = USE_STAGING ? "https://www.staging.memcachier.com/" : "https://www.memcachier.com/";

export const MEMCACHIER_STATUS_URL = USE_STAGING
  ? "https://status.staging.memcachier.com/"
  : "https://status.memcachier.com/";

export const MEMCACHIER_BLOG_URL = "https://blog.memcachier.com/";
export const MEMCACHIER_SUPPORT_URL = "http://support.memcachier.com/"; // https doesn't resolve
export const MEMCACHIER_FEEDBACK_URL = "https://memcachier.featureupvote.com/";
export const MEMCACHIER_TWITTER_URL = "https://twitter.com/MemCachier";
export const MEMCACHIER_GITHUB_URL = "https://github.com/memcachier/";
export const MEMCACHIER_CACHES_URL = MEMCACHIER_BASE_URL + "caches";
export const MEMCACHIER_ACCOUNT_URL = MEMCACHIER_BASE_URL + "users/edit";
export const MEMCACHIER_INVOICES_URL = MEMCACHIER_BASE_URL + "invoices";
export const MEMCACHIER_LOGIN_URL = MEMCACHIER_BASE_URL + "users/login";
export const MEMCACHIER_LOGOUT_URL = MEMCACHIER_BASE_URL + "users/logout";
export const MEMCACHIER_SIGN_UP_URL = MEMCACHIER_BASE_URL + "users/signup";
export const MEMCACHIER_ABOUT_URL = MEMCACHIER_BASE_URL + "about";
export const MEMCACHIER_CONTACT_URL = MEMCACHIER_BASE_URL + "contact";
export const MEMCACHIER_DOCS_URL = MEMCACHIER_BASE_URL + "documentation";
export const MEMCACHIER_DOCS_CREDENTIALS_URL = MEMCACHIER_BASE_URL + "documentation/credentials";

export const HEROKU_DASHBOARD = "https://dashboard.heroku.com";
export const HEROKU_DOCS = "https://devcenter.heroku.com/articles/memcachier";
export const HEROKU_INFO = "https://elements.heroku.com/addons/memcachier";

export const CACHESIGHT_URL = "https://cachesight.com/";
